import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowDownToBracketSharp = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.772 13.114v4.666h12.001v-4.666h2v6.666h-16v-6.666h2ZM7.105 8.81l.707.707 2.96 2.957V3.78h2v8.7l2.96-2.962.707-.707 1.415 1.413-.707.708-4.662 4.667-.707.707-.707-.707-4.672-4.667-.708-.706L7.105 8.81Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowDownToBracketSharp);
export default Memo;
